import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  wrapper: {
    display: 'flex',
    minHeight: '100vh',
    minWidth: '100vw',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.grey[100],
    },
  },
}));

export default useStyles;
